// hooks/useCueAnimation.js
import { useEffect } from 'react';

const useCueAnimation = () => {
  useEffect(() => {
    const animateElements = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const animationType = el.getAttribute('data-cue');
          const delay = parseInt(el.getAttribute('data-delay')) || 0;

          // Set initial state
          el.style.opacity = '0';
          
          // Apply different initial states based on animation type
          if (animationType === 'slideInUp') {
            el.style.transform = 'translateY(20px)';
          } else if (animationType === 'fadeIn') {
            el.style.opacity = '0';
          }

          // Animate after delay
          setTimeout(() => {
            el.style.transition = `all 0.5s ease ${delay}ms`;
            el.style.opacity = '1';
            el.style.transform = 'translateY(0)';
            
            // Disconnect observer after animation if we only want it once
            observer.unobserve(el);
          }, 100); // Small buffer before starting animation
        }
      });
    };

    // Set up Intersection Observer
    const observer = new IntersectionObserver(animateElements, {
      threshold: 0.1, // Trigger when 10% of element is visible
      rootMargin: '0px 0px -50px 0px' // Adjust this to trigger animation sooner/later
    });

    // Observe all elements with data-cue attribute
    document.querySelectorAll('[data-cue]').forEach(el => {
      observer.observe(el);
    });

    return () => {
      observer.disconnect();
    };
  }, []);
};

export default useCueAnimation;